export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const GET_DROPDOWN_LIST_REQUEST = "GET_DROPDOWN_LIST_REQUEST";
export const GET_DROPDOWN_LIST_FAILURE = "GET_DROPDOWN_LIST_FAILURE";
export const GET_DROPDOWN_LIST_SUCCESS = "GET_DROPDOWN_LIST_SUCCESS";

export const GET_DOCK_MAPPING_SUMMARY_REQUEST =
  "GET_DOCK_MAPPING_SUMMARY_REQUEST";
export const GET_DOCK_MAPPING_SUMMARY_FAILURE =
  "GET_DOCK_MAPPING_SUMMARY_FAILURE";
export const GET_DOCK_MAPPING_SUMMARY_SUCCESS =
  "GET_DOCK_MAPPING_SUMMARY_SUCCESS";

export const MAP_DOCK_BOX_REQUEST = "MAP_DOCK_BOX_REQUEST";
export const MAP_DOCK_BOX_FAILURE = "MAP_DOCK_BOX_FAILURE";
export const MAP_DOCK_BOX_SUCCESS = "MAP_DOCK_BOX_SUCCESS";

export const GET_DOCK_BY_SORTER_ID_REQUEST = "GET_DOCK_BY_SORTER_ID_REQUEST";
export const GET_DOCK_BY_SORTER_ID_FAILURE = "GET_DOCK_BY_SORTER_ID_FAILURE";
export const GET_DOCK_BY_SORTER_ID_SUCCESS = "GET_DOCK_BY_SORTER_ID_SUCCESS";

export const GET_DOCK_SETTING_REQUEST = "GET_DOCK_SETTING_REQUEST";
export const GET_DOCK_SETTING_SUCCESS = "GET_DOCK_SETTING_SUCCESS";
export const GET_DOCK_SETTING_FAILURE = "GET_DOCK_SETTING_FAILURE";

export const SAVE_DOCK_SETTING_REQUEST = "SAVE_DOCK_SETTING_REQUEST";
export const SAVE_DOCK_SETTING_SUCCESS = "SAVE_DOCK_SETTING_SUCCESS";
export const SAVE_DOCK_SETTING_FAILURE = "SAVE_DOCK_SETTING_FAILURE";

export const GET_BOX_VOLUME_SETTING_REQUEST = "GET_BOX_VOLUME_SETTING_REQUEST";
export const GET_BOX_VOLUME_SETTING_SUCCESS = "GET_BOX_VOLUME_SETTING_SUCCESS";
export const GET_BOX_VOLUME_SETTING_FAILURE = "GET_BOX_VOLUME_SETTING_FAILURE";

export const SAVE_BOX_VOLUME_SETTING_REQUEST =
  "SAVE_BOX_VOLUME_SETTING_REQUEST";
export const SAVE_BOX_VOLUME_SETTING_SUCCESS =
  "SAVE_BOX_VOLUME_SETTING_SUCCESS";
export const SAVE_BOX_VOLUME_SETTING_FAILURE =
  "SAVE_BOX_VOLUME_SETTING_FAILURE";

export const MAP_DOCK_LIST_REQUEST = "MAP_DOCK_LIST_REQUEST";
export const MAP_DOCK_LIST_SUCCESS = "MAP_DOCK_LIST_SUCCESS";
export const MAP_DOCK_LIST_FAILURE = "MAP_DOCK_LIST_FAILURE";

export const ADD_SESSION__REQUEST = "ADD_SESSION__REQUEST";
export const ADD_SESSION__SUCCESS = "ADD_SESSION__SUCCESS";
export const ADD_SESSION__FAILURE = "ADD_SESSION__FAILURE";

export const GET_SESSION_SUMMARY_REQUEST = "GET_SESSION_SUMMARY_REQUEST";
export const GET_SESSION_SUMMARY_SUCCESS = "GET_SESSION_SUMMARY_SUCCESS";
export const GET_SESSION_SUMMARY_FAILURE = "GET_SESSION_SUMMARY_FAILURE";

export const GET_SESSION_DETAIL_REQUEST = "GET_SESSION_DETAIL_REQUEST";
export const GET_SESSION_DETAIL_SUCCESS = "GET_SESSION_DETAIL_SUCCESS";
export const GET_SESSION_DETAIL_FAILURE = "GET_SESSION_DETAIL_FAILURE";

export const GET_SKU_REQUEST = "GET_SKU_REQUEST";
export const GET_SKU_SUCCESS = "GET_SKU_SUCCESS";
export const GET_SKU_FAILURE = "GET_SKU_FAILURE";

export const ASSIGN_BOX_REQUEST = "ASSIGN_BOX_REQUEST";
export const ASSIGN_BOX_SUCCESS = "ASSIGN_BOX_SUCCESS";
export const ASSIGN_BOX_FAILURE = "ASSIGN_BOX_FAILURE";

export const CANCEL_SESSION_REQUEST = "CANCEL_SESSION_REQUEST";
export const CANCEL_SESSION_SUCCESS = "CANCEL_SESSION_SUCCESS";
export const CANCEL_SESSION_FAILURE = "CANCEL_SESSION_FAILURE";

export const FORCE_CLOSE_REQUEST = "FORCE_CLOSE_REQUEST";
export const FORCE_CLOSE_SUCCESS = "FORCE_CLOSE_SUCCESS";
export const FORCE_CLOSE_FAILURE = "FORCE_CLOSE_FAILURE";

export const CREATE_PLAN_REQUEST = "CREATE_PLAN_REQUEST";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_FAILURE = "CREATE_PLAN_FAILURE";

export const GET_SORTER_SESSION_HISTORY_REQUEST =
  "SGET_SORTER_SESSION_HISTORY_REQUEST";
export const GET_SORTER_SESSION_HISTORY_SUCCESS =
  "SGET_SORTER_SESSION_HISTORY_SUCCESS";
export const GET_SORTER_SESSION_HISTORY_FAILURE =
  "SGET_SORTER_SESSION_HISTORY_FAILURE";

export const GET_SKU_WISE_SORTATION_PLAN_REQUEST =
  "SGET_SKU_WISE_SORTATION_PLAN_REQUEST";
export const GET_SKU_WISE_SORTATION_PLAN_SUCCESS =
  "SGET_SKU_WISE_SORTATION_PLAN_SUCCESS";
export const GET_SKU_WISE_SORTATION_PLAN_FAILURE =
  "SGET_SKU_WISE_SORTATION_PLAN_FAILURE";

export const GET_REJECTION_DATA_REQUEST = "GET_REJECTION_DATA_REQUEST";
export const GET_REJECTION_DATA_SUCCESS = "GET_REJECTION_DATA_SUCCESS";
export const GET_REJECTION_DATA_FAILURE = "GET_REJECTION_DATA_FAILURE";

export const ADD_BOX_TYPE_REQUEST = "ADD_BOX_TYPE_REQUEST";
export const ADD_BOX_TYPE_SUCCESS = "ADD_BOX_TYPE_SUCCESS";
export const ADD_BOX_TYPE_FAILURE = "ADD_BOX_TYPE_FAILURE";

export const GET_ACTIVE_SESSION_REQUEST = "GET_ACTIVE_SESSION_REQUEST";
export const GET_ACTIVE_SESSION_SUCCESS = "GET_ACTIVE_SESSION_SUCCESS";
export const GET_ACTIVE_SESSION_FAILURE = "GET_ACTIVE_SESSION_FAILURE";

export const SAVE_INVENTORY_INCOMING_REQUEST =
  "SAVE_INVENTORY_INCOMING_REQUEST";
export const SAVE_INVENTORY_INCOMING_SUCCESS =
  "SAVE_INVENTORY_INCOMING_SUCCESS";
export const SAVE_INVENTORY_INCOMING_FAILURE =
  "SAVE_INVENTORY_INCOMING_FAILURE";

export const GET_INVENTORY_INCOMING_REQUEST = "GET_INVENTORY_INCOMING_REQUEST";
export const GET_INVENTORY_INCOMING_SUCCESS = "GET_INVENTORY_INCOMING_SUCCESS";
export const GET_INVENTORY_INCOMING_FAILURE = "GET_INVENTORY_INCOMING_FAILURE";

export const DELETE_DOCK_MAP_REQUEST = "DELETE_DOCK_MAP_REQUEST";
export const DELETE_DOCK_MAP_SUCCESS = "DELETE_DOCK_MAP_SUCCESS";
export const DELETE_DOCK_MAP_FAILURE = "DELETE_DOCK_MAP_FAILURE";

export const BOX_MOVE_REQUEST = "BOX_MOVE_REQUEST";
export const BOX_MOVE_SUCCESS = "BOX_MOVE_SUCCESS";
export const BOX_MOVE_FAILURE = "BOX_MOVE_FAILURE";

export const GET_SUB_LOCATION_BY_INVENTORY_REQUEST =
  "GET_SUB_LOCATION_BY_INVENTORY_REQUEST";
export const GET_SUB_LOCATION_BY_INVENTORY_SUCCESS =
  "GET_SUB_LOCATION_BY_INVENTORY_SUCCESS";
export const GET_SUB_LOCATION_BY_INVENTORY_FAILURE =
  "GET_SUB_LOCATION_BY_INVENTORY_FAILURE";

export const ADD_PRODUCT_VOLUME_REQUEST = "ADD_PRODUCT_VOLUME_REQUEST";
export const ADD_PRODUCT_VOLUME_SUCCESS = "ADD_PRODUCT_VOLUME_SUCCESS";
export const ADD_PRODUCT_VOLUME_FAILURE = "ADD_PRODUCT_VOLUME_FAILURE";

export const BOX_PDF_BULK_REQUEST = "BOX_PDF_BULK_REQUEST";
export const BOX_PDF_BULK_SUCCESS = "BOX_PDF_BULK_SUCCESS";
export const BOX_PDF_BULK_FAILURE = "BOX_PDF_BULK_FAILURE";

export const SAVE_ASSOCIATED_BOX_VOLUME_REQUEST =
  "SAVE_ASSOCIATED_BOX_VOLUME_REQUEST";
export const SAVE_ASSOCIATED_BOX_VOLUME_SUCCESS =
  "SAVE_ASSOCIATED_BOX_VOLUME_SUCCESS";
export const SAVE_ASSOCIATED_BOX_VOLUME_FAILURE =
  "SAVE_ASSOCIATED_BOX_VOLUME_FAILURE";

export const GET_ASSOCIATED_DOCK_SETTING_REQUEST =
  "SAVE_ASSOCIATED_BOX_VOLUME_REQUEST";
export const GET_ASSOCIATED_DOCK_SETTING_SUCCESS =
  "SAVE_ASSOCIATED_BOX_VOLUME_SUCCESS";
export const GET_ASSOCIATED_DOCK_SETTING_FAILURE =
  "SAVE_ASSOCIATED_BOX_VOLUME_FAILURE";

export const GET_DOCK_ASSOCIATED_BOX_LABEL_REQUEST =
  "GET_DOCK_ASSOCIATED_BOX_LABEL_REQUEST";
export const GET_DOCK_ASSOCIATED_BOX_LABEL_SUCCESS =
  "GET_DOCK_ASSOCIATED_BOX_LABEL_SUCCESS";
export const GET_DOCK_ASSOCIATED_BOX_LABEL_FAILURE =
  "GET_DOCK_ASSOCIATED_BOX_LABEL_FAILURE";

export const PRINT_ASSOCIATED_BOX_LABEL_BULK_REQUEST =
  "PRINT_ASSOCIATED_BOX_LABEL_BULK_REQUEST";
export const PRINT_ASSOCIATED_BOX_LABEL_BULK_SUCCESS =
  "PRINT_ASSOCIATED_BOX_LABEL_BULK_SUCCESS";
export const PRINT_ASSOCIATED_BOX_LABEL_BULK_FAILURE =
  "PRINT_ASSOCIATED_BOX_LABEL_BULK_FAILURE";

export const CREATE_SESSION_DYN_REQUEST = "CREATE_SESSION_DYN_REQUEST";
export const CREATE_SESSION_DYN_SUCCESS = "CREATE_SESSION_DYN_SUCCESS";
export const CREATE_SESSION_DYN_FAILURE = "CREATE_SESSION_DYN_FAILURE";

export const REMOVE_SESSION_REQUEST = "REMOVE_SESSION_REQUEST";
export const REMOVE_SESSION_SUCCESS = "REMOVE_SESSION_SUCCESS";
export const REMOVE_SESSION_FAILURE = "REMOVE_SESSION_FAILURE";

export const BOX_CREATE_BULK_REQUEST = "BOX_CREATE_BULK_REQUEST";
export const BOX_CREATE_BULK_SUCCESS = "BOX_CREATE_BULK_SUCCESS";
export const BOX_CREATE_BULK_FAILURE = "BOX_CREATE_BULK_FAILURE";

export const GET_BOX_LIST_REQUEST = "GET_BOX_LIST_REQUEST";
export const GET_BOX_LIST_SUCCESS = "GET_BOX_LIST_SUCCESS";
export const GET_BOX_LIST_FAILURE = "GET_BOX_LIST_FAILURE";

export const GET_BOX_LABEL_REQUEST = "GET_BOX_LABEL_REQUEST";
export const GET_BOX_LABEL_SUCCESS = "GET_BOX_LABEL_SUCCESS";
export const GET_BOX_LABEL_FAILURE = "GET_BOX_LABEL_FAILURE";

export const GET_DOCK_ASSOCIATED_BOX_REQUEST =
  "GET_DOCK_ASSOCIATED_BOX_REQUEST";
export const GET_DOCK_ASSOCIATED_BOX_SUCCESS =
  "GET_DOCK_ASSOCIATED_BOX_SUCCESS";
export const GET_DOCK_ASSOCIATED_BOX_FAILURE =
  "GET_DOCK_ASSOCIATED_BOX_FAILURE";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
